<div class="my-account-page">
  <ysh-page-header title="My Account"/>
  <div class="panels">
    <ysh-panel
      class="panel"
      heading="Personal Info"
      padding="left-right-bottom">

      <ysh-traits [traits]="userInfo" imageSrc="assets/images/avatar-default-blue.png"/>
    </ysh-panel>
    
    @if (userCompanies?.length) {
      <ysh-panel
        class="panel"
        heading="Companies"
        infotip="Company affiliations & roles"
        padding="left-right-bottom">

        <ysh-traits [traits]="userCompanies" labelOpacity="full"/>
      </ysh-panel>
    }

    <ysh-panel
      class="panel"
      heading="Your Payment Method"
      [actionLabel]="userCreditCardInfo ? 'Change' : 'Add Card'"
      (onAction)="handleAddCreditCard()"
      padding="left-right-bottom">

      @if(userCreditCardInfo) {
        <ysh-traits [traits]="userCreditCardInfo"/>
      } @else {
        <p class="panel__empty">
          No card on file. Needed for services billed to you, and for cancellation
          or no-show fees on services your company pays for.
        </p>
      }
    </ysh-panel>
  </div>
</div>
